export const parseDataTable = (data: any) => {
  if( data && data.length > 0 ){
    return data.map((item: any) => {
      return {
        id: item.id,
        code: item.code,
        type: getType(item),
        asset: item.listing,
        subject: {title: item.title, sub_title: item.subtitle},
        seller: {user: item.seller, broker: item.seller_broker},
        buyer: {user: item.buyer, broker: item.buyer_broker},
        commission: {
          seller: { p: item.seller_broker_percent, a: item.seller_broker_amount },
          buyer: { p: item.buyer_broker_percent, a: item.buyer_broker_amount }
        },
        status: item.status,
        signed_at: item.signed_at,
        created_at: item.created_at,
        action_by: '--',
      }
    })
  }
  return []
}

function getType(item: any){
  switch (item.type){
    default: return [{type: 'info', label: item.type}]
  }
}
